export enum SubscriptionType {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export const SUBSCRIPTION_DETAILS: Record<SubscriptionType, { amount: number }> = {
  [SubscriptionType.MONTHLY]: {
    amount: 1000
  },
  [SubscriptionType.YEARLY]: {
    amount: 9000
  }
};

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}

export interface Subscription {
  id?: string;
  propId: string;
  amount: number;
  type: SubscriptionType;
  status: SubscriptionStatus;
  expiresOn?: Date;
}
